import React from "react"
import PropTypes from "prop-types"
import get from "lodash/get"
import httpMessages from "http-status-messages"

/**
 * Used in TableFromApi and DealImportantInfoContainer
 * @param error
 * @returns {*}
 */
const parseError = (error) => {
  if (!get(error, "response.status", false)) {
    // Errors without status codes
    return {
      description: "perks.helpers.utils.getNetworkCatchError.error.errorDetected",
      message: (
        /* eslint-disable no-nested-ternary */
        typeof error === "string"
          ? error
          : error.message && typeof error.message === "string"
            ? error.message
            : String(error) !== "[object Object]"
              ? String(error)
              : "perks.helpers.utils.getNetworkCatchError.error.unknownError"
      /* eslint-enable no-nested-ternary */
      )
    }
  }
  // Errors with status codes (probably HTTP network errors)
  const bodyMessage = get(error, "response.data.message", null)
  let message
  if (error.message) {
    message = error.message
  } else if (bodyMessage) {
    message = `${httpMessages[error.response.status]} - ${bodyMessage}`
  } else {
    message = httpMessages[error.response.status]
  }
  if (error.response.status >= 400 && error.response.status <= 499) {
    return {
      description: "perks.helpers.utils.getNetworkCatchError.error.browserError",
      message
    }
  }
  if (error.response.status >= 500 && error.response.status <= 599) {
    return {
      description: "perks.helpers.utils.getNetworkCatchError.error.serverError",
      message
    }
  }
  return {
    description: "perks.helpers.utils.getNetworkCatchError.error.errorDetected",
    message: `"${error}"`
  }
}

export default parseError

export const ErrorValue = (props) => (
  <div data-test="error-value" className="parsed-network-error">
    <strong>{`${props.source.description}!`}</strong>
    <br />
    <span>{props.source.message}</span>
  </div>
)


ErrorValue.propTypes = {
  source: PropTypes.shape({
    description: PropTypes.string,
    message: PropTypes.string
  }).isRequired
}
